"use strict";

Shopify.theme.jsHeroBannerSlider = {
  init: function init($section) {
    Shopify.theme.jsHeroBannerSlider = $.extend(this, Shopify.theme.getSectionData($section));

    var $sliderEl = $section.find('[data-hero-banner-slider]').removeClass('is-hidden');
    var slideCount = this.number_of_slides || 0;

    if (slideCount < 1) return;

    var $slider = $sliderEl.flickity({
      wrapAround: true,
      adaptiveHeight: true,
      prevNextButtons: slideCount > 1 ? this.show_arrows : false,
      pageDots: slideCount > 1 ? this.show_nav_buttons : false,
      draggable: slideCount > 1,
      imagesLoaded: true,
      fade: this.image_transition === 'fade',
      autoPlay: slideCount > 1 ? this.image_slideshow_speed * 1000 : false,
      arrowShape: arrowShape
    });

    $sliderEl.on('settle.flickity', function () {
      $sliderEl.flickity('resize');
    });
  },
  unload: function unload($section) {
    var $slider = $section.find('.flickity-enabled');
    if ($slider.length) {
      $slider.flickity('destroy');
    }
  }
};
